import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { Tipologia } from 'app/modules/models/tipologia.model';
import { CatalogosService } from 'app/modules/admin/catalogos/catalogos.service';
import { A11yModule } from "@angular/cdk/a11y";

interface AgregarCatalogoData {
    tipologiaPadreId?: number;
    titulo?: string;
    tipologia?: Tipologia;
}

@Component({
    selector: 'app-agregar-catalogo',
    templateUrl: 'agregar-catalogo.component.html',
    standalone: true,
    imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    A11yModule
]
})
export class AgregarCatalogoComponent {
    tituloCabecera = 'Nuevo Catálogo';
    titulo = 'Nuevo catálogo';
    esEdicion = false;
    model: Tipologia = {
        tipologiaId: 0,
        descripcion: '',
        tipologiaPadreId: undefined,
        valor1: '',
        valor2: ''
    };

    constructor(
        private _catalogosService: CatalogosService,
        public dialogRef: MatDialogRef<AgregarCatalogoComponent>,
        @Inject(MAT_DIALOG_DATA) public data?: AgregarCatalogoData
    ) {
        if (data?.tipologia) {
            this.esEdicion = true;
            this.tituloCabecera = 'Editar Catálogo';
            this.model = {
                tipologiaId: data.tipologia.tipologiaId ?? 0,
                descripcion: data.tipologia.descripcion ?? '',
                tipologiaPadreId: data.tipologia.tipologiaPadreId,
                valor1: data.tipologia.valor1 ?? '',
                valor2: data.tipologia.valor2 ?? ''
            };
        }
        if (data?.titulo) {
            this.titulo = data.titulo;
        }
        if (data?.tipologiaPadreId) {
            this.model.tipologiaPadreId = data.tipologiaPadreId;
        }
        if (this.esEdicion && !data?.titulo) {
            this.titulo = this.model.descripcion || 'Editar catálogo';
        }
    }

    async submit(form: NgForm): Promise<void> {
        if (form.invalid) {
            return;
        }
        try {
            if (this.esEdicion) {
                await this._catalogosService.actualizarTipologia(this.model);
            } else {
                await this._catalogosService.CrearTipologia(this.model);
            }
            this.dialogRef.close(true);
        } catch (error) {
            console.error('Error al guardar catálogo:', error);
        }
    }
}
